<label class="form-label d-block text-truncate" [for]="id" [title]="labelName">
  {{ labelName }}
  @if (required) {
    <span class="ml-1 fs-6">*</span>
  }
  @if (checkCyrillic && cyrillicChars.length > 0) {
    <span class="form-label warning-message text-warning text-wrap" [title]="cyrillicChars">({{ cyrillicWarningMessage }}: {{ cyrillicChars }})</span>
  }
</label>

<input
  [name]="name"
  [title]="value ?? ''"
  title="Название поля"
  [id]="id"
  [required]="required"
  [disabled]="disabled"
  [readonly]="readonly || disabled || control.disabled"
  [placeholder]="readonly || disabled ? '' : placeholder"
  [value]="value ?? control.value"
  [maxLength]="maxLength"
  [minLength]="minLength"
  [ngClass]="{
    'form-control-plaintext': plaintext,
    'form-control': !plaintext,
    'is-invalid': control.invalid && control.touched && !plaintext,
     'uppercase': uppercase,
  }"
  [type]="showPassword ? 'text' : type"
  (input)="onChange($any($event.target).value)"
  (blur)="onBlur($event)"
  (keypress)="onKeyPress($event)"
  (paste)="onPaste($event)"
/>

@if (type === 'password') {
  <span
    class="eye-icon"
    [ngClass]="{ 'invalid-eye-icon': control.invalid && control.touched && !plaintext }"
    (click)="togglePasswordVisibility()"
  >
    <fa-icon [icon]="showPassword ? faEye : faEyeSlash"></fa-icon>
  </span>
}


@if (control.invalid && !this.disabled && !this.readonly) {
  <div class="invalid-feedback">
    {{ getErrorMessage() }}
  </div>
}
